export type LevelType = 'normal' | 'charging_boss' | 'wave_event';

// Оверрайд для особого уровня (боссовые milestone-уровни). Остальные уровни =
// генерируются процедурно WaveGenerator'ом из доступных врагов по таблице открытия.
export interface LevelOverride {
  level: number;
  type: LevelType;
  bossId?: string;
}

// Боссы каждые 5 уровней (структурная пересборка W2). Порядок боссов сохранён;
// сдвинуты только номера −5. 9 боссов = 9 регионов по 5 уровней (4 обычных + босс).
export const LEVEL_OVERRIDES: LevelOverride[] = [
  { level: 5, type: 'charging_boss', bossId: 'big_boar' },
  { level: 10, type: 'wave_event', bossId: 'boarling_wave' },
  { level: 15, type: 'wave_event', bossId: 'fox_wave' },
  { level: 20, type: 'wave_event', bossId: 'deer_wave' },
  { level: 25, type: 'charging_boss', bossId: 'elk' },
  { level: 30, type: 'charging_boss', bossId: 'honey_badger' },
  { level: 35, type: 'wave_event', bossId: 'wolf_wave' },
  { level: 40, type: 'charging_boss', bossId: 'camel' },
  { level: 45, type: 'charging_boss', bossId: 'bear' },
];

export const MAX_LEVEL = 45;

export function getLevelOverride(level: number): LevelOverride | null {
  return LEVEL_OVERRIDES.find((o) => o.level === level) ?? null;
}
